import * as React from 'react';
import { fcmService } from '../services/fcmService';
import { useNotification } from './CustomNotification';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Component that listens to Firebase foreground messages
 * and displays them using the notification system
 */
export function FirebaseNotificationListener() {
  const { show } = useNotification();
  const { language } = useLanguage();
  const { isAuthenticated } = useAuth();

  React.useEffect(() => {
    // Only subscribe if user is authenticated
    if (!isAuthenticated) {
      return;
    }

    // Subscribe to foreground messages
    const unsubscribe = fcmService.onMessage((payload) => {
      console.log('Foreground message received:', payload);

      // Extract notification data
      const notification = payload.notification;
      const data = payload.data;

      // Determine the message to display based on language
      let message = '';
      if (language === 'ar' && data?.arabic_message) {
        message = data.arabic_message;
      } else if (language === 'en' && data?.english_message) {
        message = data.english_message;
      } else if (notification?.body) {
        message = notification.body;
      } else {
        message = 'New notification received';
      }

      // Show notification
      show(message, {
        severity: 'info',
        autoHideDuration: 5000,
      });
    });

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
    };
  }, [isAuthenticated, language, show]);

  // This component doesn't render anything
  return null;
}

